import { render, staticRenderFns } from "./DeleteCard.vue?vue&type=template&id=bebcc2e4"
import script from "./DeleteCard.vue?vue&type=script&lang=js"
export * from "./DeleteCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports